import React, { useState } from 'react';
import '../css/Formulario.css';
import { ReactComponent as Logo6BFormulario } from '../assets/svg/6blogo.svg';
import { ReactComponent as OjoIcono } from '../assets/icon/ojoIcono.svg';
import { ReactComponent as OjoCerradoIcono } from '../assets/icon/ojoCerrado.svg';
import { useNavigate } from "react-router-dom";
import { loginUsuario } from '../services';

function Formulario() {
  const navigate = useNavigate();
  const [mostrarPassword, setMostrarPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const oprimirboton = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!email || !password) {
      setError('Por favor ingresa email y contraseña');
      return;
    }

    setLoading(true);

    try {
      const result = await loginUsuario(email, password);
      
      if (result.success && result.error === 0) {
        navigate("/dashboard/inicio");
      } else {
        setError(result.mensaje || 'Error al iniciar sesión');
      }
    } catch (err) {
      setError(err.message || 'Error de conexión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="cuerpo">
      <div className="contenedor">
        <div className="svgFormulario"><Logo6BFormulario className="logosvgFormulario" /></div>
        <div className="login-container">
          <div className='TEXTOS'>
            <div className="titulo">
              <h1>Iniciar Sesión</h1>
            </div>
            <div className="subtitulo">
              <h2>Porfavor Inicio sesión para continuar</h2>
            </div>
          </div>

          <div className='cuerpoinput'>
            {/* 🔐 Campo email */}
            <div className="input-group">
              <div className='text-input'>
                <label htmlFor="email">Correo electrónico</label>
              </div>
              <input
                className="input"
                type="email"
                id="email"
                placeholder="Ingresa tu correo electrónico"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                disabled={loading}
              />
            </div>

            {/* 🔐 Campo contraseña */}
            <div className="input-group">
              <div className='text-input'>
                <label htmlFor="password">Contraseña</label>
              </div>
              <div className="input-wrapper">
                <input
                  className="input input-password"
                  type={mostrarPassword ? "text" : "password"}
                  id="password"
                  placeholder="Ingresa la contraseña"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                />
                <div
                  className="icono-ojo"
                  onClick={() => setMostrarPassword(!mostrarPassword)}
                >
                  {mostrarPassword ? <OjoIcono /> : <OjoCerradoIcono />}
                </div>
              </div>
            </div>
          </div>

          {error && <div className="login-error">{error}</div>}

          <button type="button" className="btn-accept" id="login" onClick={oprimirboton} disabled={loading}>
            {loading ? 'Iniciando sesión...' : 'Iniciar sesión'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Formulario;
